import React from 'react';
import { Form, Input, Typography } from 'antd';

const { TextArea } = Input;
const { Text } = Typography;

type Props = {
  note: string;
  onNoteChange: (value: string) => void;
};

/** Ghi chú nội bộ cho duyệt/chi hộ rút tiền merchant. */
export function WithdrawalDisbursementModalFields({
  note,
  onNoteChange,
}: Props) {
  return (
    <Form layout="vertical" requiredMark="optional">
      <Form.Item label="Ghi chú" extra={<Text type="secondary">Tuỳ chọn</Text>}>
        <TextArea
          rows={3}
          placeholder="Ghi chú nội bộ cho lệnh rút này"
          value={note}
          onChange={e => onNoteChange(e.target.value)}
        />
      </Form.Item>
    </Form>
  );
}
